import { compose } from 'redux';
import { connect } from 'react-redux';
import { attSubPage } from 'decorators/subPage';
import injectPreactivation from 'decorators/injectPreactivation';
import AttSubNav from 'components/SubNav/att';
import { reset } from 'redux-resource-plugins';
import { updateDevice } from 'actions/attSubs';
import { fetchAllPlans } from 'actions/attPlans';
import {
  getIsAdmin,
  getSubmitStatus,
  getAttDeviceDetails,
  getAllAttPlans,
} from 'reducers';

import UpdateDevice from './UpdateDevice';

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'device'),
  deviceDetails: getAttDeviceDetails(state),
  isAdmin: getIsAdmin(state),
  plans: getAllAttPlans(state),
  resourceType: 'attSubs',
  SubNav: AttSubNav,
  heading: 'Update AT&T Device',
  isAtt: true,
});

const mapDispatchToProps = {
  resetResource: reset.resetResource,
  updateDevice,
  fetchAllPlans,
};

export default compose(
  attSubPage,
  injectPreactivation,
  connect(mapStateToProps, mapDispatchToProps),
)(UpdateDevice);
